import { applicantsSlice } from './applicants.slice.ts';

export const { updateApplicantDataSet, resetApplicant } = applicantsSlice.actions;
